import EventBase from './EventBase'
import EventID from './EventID'

/**
 * 700 - 显示视频事件
 */
import EventFilter from './EventFilter'

export default class EventPicShow extends EventBase {
    /**
     * 显示图片事件构造函数
     */
    constructor() {
        super()
        this.Parameter = ['0', '', '0', '0', '0', '100', '100', '255', '0', '0', '2', '0', '0', '0']
    }

    /**
     * 事件ID
     */
    Code = EventID.VideoShow
    // #region 事件内关键属性参数
    /**
     * 视频 ID，同显示图片 ID
     */
    get VideoId() {
        return parseInt(this.Parameter?.[0] ?? '')
    }
    set VideoId(value) {
        this.Parameter && (this.Parameter[0] = value.toString())
    }

    /**
     * 视频相对路径
     */
    get VideoPath() {
        return this.Parameter?.[1] || ''
    }
    set VideoPath(value) {
        this.Parameter && (this.Parameter[1] = value.toString())
    }

    /**
     * 视频坐标是否为橙光数值指定
     * 0为非数值指定（常量），1为是橙光动态数值指定
     */
    get IsAssigned() {
        return this.Parameter?.[2] == '1'
    }
    set IsAssigned(value) {
        this.Parameter && (this.Parameter[2] = value ? '1' : '0')
    }
    /**
     * X坐标
     */
    get X() {
        return parseInt(this.Parameter?.[3] || '')
    }
    set X(value) {
        this.Parameter && (this.Parameter[3] = value.toString())
    }
    /**
     * Y坐标
     */
    get Y() {
        return parseInt(this.Parameter?.[4] || '')
    }
    set Y(value) {
        this.Parameter && (this.Parameter[4] = value.toString())
    }
    /**
     * X轴缩放率
     */
    get ZoomX() {
        return parseInt(this.Parameter?.[5] ?? '')
    }
    set ZoomX(value) {
        this.Parameter && (this.Parameter[5] = value.toString())
    }

    /**
     * Y轴缩放率
     */
    get ZoomY() {
        return parseInt(this.Parameter?.[6] ?? '')
    }
    set ZoomY(value) {
        this.Parameter && (this.Parameter[6] = value.toString())
    }

    /**
     * 视频音量 0~100
     */
    get Volume() {
        return parseInt(this.Parameter?.[7] ?? '')
    }
    set Volume(value) {
        this.Parameter && (this.Parameter[7] = value.toString())
    }

    /**
     * 是否循环播放，1 是，0 最后一帧停止
     */
    get IsLoop() {
        return this.Parameter?.[8] == '1'
    }
    set IsLoop(value) {
        this.Parameter && (this.Parameter[8] = value ? '1' : '0')
    }

    /**
     * 描述信息
     */
    get Description() {
        return this.Parameter?.[9] || ''
    }
    set Description(value) {
        this.Parameter && (this.Parameter[9] = value.toString())
    }

    /**
     * 是否素材来源自云网盘
     * 2是（云网盘公有区资源）
     */
    get IsPublicwebdisk() {
        return this.Parameter?.[10] == '2'
    }
    set IsPublicwebdisk(value) {
        this.Parameter && (this.Parameter[10] = value ? '2' : '1')
    }

    /**
     * 图片名称是否为橙光字符串指定
     * 0为是非字符串指定（固定图片），1为是橙光动态字符串指定
     */
    get IsUserStrAssigned() {
        return this.Parameter?.[11] == '1'
    }
    set IsUserStrAssigned(value) {
        this.Parameter && (this.Parameter[11] = value ? '1' : '0')
    }

    /**
     * 指定的为橙光字符串索引
     * 如果不存在则返回0
     */
    get UserAssignedStrID() {
        return this.IsUserStrAssigned ? parseInt(this.Parameter?.[12] ?? '') : 0
    }
    set UserAssignedStrID(value) {
        this.Parameter && (this.Parameter[12] = this.IsUserStrAssigned ? value + '' : '0')
    }

    get IsClickSkip() {
        return this.Parameter[13] == '1'
    }

    set IsClickSkip(val) {
        this.Parameter[13] = Number(!!val).toString()
    }

    // #endregion

    /**
     * 获得该事件在事件列表的描述信息（对于显示图片而言，是第9项）
     */
}
